import React, { useState, useEffect, Suspense } from 'react';
import { connect } from "react-redux";
import { useDispatch } from '../reducers/store';
import { setCrumb } from '../reducers/global';
import { getInvoice, createInvoice, deleteInvoice } from '../reducers/invoices';
import ClientSelectorComponent from './ClientSelectorComponent';
import LineItemComponent from '../components/LineItemComponent'
//import Editor from '../components/Editor'
import SendInvoice from '../components/SendInvoice'
import PayInvoice from '../components/PayInvoice'
import CreditNote from '../components/CreditNote'
import SwitchEditComponent from '../components/SwitchEdit'
import ItemEditComponent from '../components/TextEdit'
import ItemDateComponent from '../components/DateEdit'
import moment from 'moment'
import DownloadLink from "react-download-link";
import urls from '../network/urls';
import Select from './SelectComponent'
import Alert from "./glass/GlassAlert";
import { colors } from '../theme';
import { documentFilename } from '../helpers/documentName';
// pdf.js is ~330KB gzipped; load it only when a preview is opened rather
// than on every page. (The 'process is not defined' crash that killed the
// earlier react-pdf lazy chunk is handled by the shim in public/index.html.)
const PdfCanvas = React.lazy(() => import('../components/PdfCanvas'));
// PDF preview uses the browser's native viewer via <iframe> (see preview block
// below). react-pdf/pdfjs was removed — its lazy chunk crashed the editor with
// "process is not defined" under this CRA 3.4.0 / webpack 4 build.


const AddInvoiceComponent = ({
    onChangeText,
    templates,
    deleteInvoice,
    updateshowAdd,
    selectedCompanyId,
    cancelChange,
    compare,
    saveInvoice, error, invoice, addInvoice, authUser, company }) => {

    const [edit, setEdit] = useState(!(addInvoice && addInvoice._id))
    const [showSend, setShowSend] = useState(false)
    const [showPaid, setShowPaid] = useState(false)
    const [showCredit, setShowCredit] = useState(false)
    const [saving, setSaving] = useState(false)
    const [showPreview, setShowPreview] = useState(false)
    const [previewLoading, setPreviewLoading] = useState(false)
    const [previewUrl, setPreviewUrl] = useState(null)
    // Raw bytes for the in-page renderer; previewUrl stays for "open in new tab".
    const [previewData, setPreviewData] = useState(null)
    const [numPages, setNumPages] = useState(null)
    const [pageNumber, setPageNumber] = useState(1)

    // What kind of document this is, and the number it goes by. A credit note
    // has no invoiceNumber — it carries its own CRN — so reading invoiceNumber
    // blindly renders "Invoice #undefined".
    const docKind = (d) => d && d.isCreditNote ? 'Credit note' : (d && d.isQuote ? 'Quote' : 'Invoice');
    const docNo = (d, src) => {
        const s = src || d || {};
        if (d && d.isCreditNote) return s.creditNoteNumber || d.creditNoteNumber;
        if (d && d.isQuote) return s.quoteNumber;
        return s.invoiceNumber;
    };
    const docTitle = (d, src) => {
        if (!d) return null;
        if (!d._id) return 'New ' + docKind(d).toLowerCase();
        const n = docNo(d, src);
        return docKind(d) + (n ? ' #' + n : '');
    };

    // Topbar sub-breadcrumb: Invoices › <this editor's title>
    const crumbTitle = docTitle(addInvoice, invoice);
    const _crumbDispatch = useDispatch();
    useEffect(() => {
        _crumbDispatch(setCrumb(crumbTitle));
        return () => _crumbDispatch(setCrumb(null));
    }, [crumbTitle]);

    // Exit (back) — confirm if there are unsaved changes
    const requestBack = () => {
        if (compare && compare()) { updateshowAdd(false); return; }
        Alert.fire({
            title: 'Discard unsaved changes?',
            text: 'Your changes to this invoice will be lost.',
            showDenyButton: true,
            showCancelButton: false,
            confirmButtonText: 'Keep editing',
            denyButtonText: 'Discard',
        }).then((r) => { if (r.isDenied) updateshowAdd(false); });
    };

    const onDocumentLoadSuccess = ({ numPages }) => {
        setNumPages(numPages);
        setPageNumber(1);
    };

    // Unified design styles
    const darkHeaderStyle = {
        background: '#1a3a4a',
        borderRadius: '8px 8px 0 0',
        padding: '16px 24px',
        display: 'flex',
        justifyContent: 'space-between',
        alignItems: 'center'
    };

    const darkHeaderTitleStyle = {
        margin: 0,
        fontSize: 18,
        fontWeight: 600,
        color: 'white'
    };

    const cardStyle = {
        background: 'transparent',
        padding: '20px 22px 40px 22px'
    };

    const sectionHeaderStyle = {
        fontSize: 15,
        fontWeight: 600,
        color: '#1a3a4a',
        marginBottom: 16,
        paddingBottom: 10,
        borderBottom: '2px solid #19a6b7',
        textTransform: 'uppercase',
        letterSpacing: '0.5px',
        marginTop: 24
    };

    const statusBadgeStyle = {
        display: 'inline-block',
        padding: '6px 16px',
        borderRadius: 20,
        fontSize: 12,
        fontWeight: 500
    };

    const buttonStyle = {
        padding: '10px 20px',
        borderRadius: 6,
        border: 'none',
        fontWeight: 500,
        cursor: 'pointer',
        fontSize: 14,
        display: 'inline-flex',
        alignItems: 'center',
        gap: 8
    };

    // Light-glass header button styles (header is frosted white, not dark)
    const hdrIconBtn = { background: 'rgba(15,31,46,0.06)', border: 'none', color: 'var(--text-secondary)', width: 36, height: 36, borderRadius: 9, cursor: 'pointer', display: 'flex', alignItems: 'center', justifyContent: 'center', textDecoration: 'none' };
    const hdrTealBtn = { background: 'linear-gradient(135deg, var(--primary), var(--primary-dark))', border: 'none', color: '#fff', padding: '8px 16px', borderRadius: 9, cursor: 'pointer', display: 'flex', alignItems: 'center', gap: 6, fontWeight: 700, fontFamily: 'var(--font-display)', fontSize: 13 };
    const hdrGhostBtn = { background: 'rgba(15,31,46,0.06)', border: '1px solid rgba(15,31,46,0.1)', color: 'var(--text-secondary)', padding: '8px 16px', borderRadius: 9, cursor: 'pointer', fontWeight: 600, fontFamily: 'var(--font-display)', fontSize: 13 };

    const getDataFromURL = (url, user) => new Promise((resolve, reject) => {
        setTimeout(() => {
            let req = {
                headers: {
                    username: user.username,
                    token: user.token,
                    AUTHORIZATION: user.token
                },
                method: 'GET'
            }

            fetch(url, req)
                .then(response => response.blob())
                .then(data => {
                    resolve(data)
                });
        });
    }, 2000);

    const openPreview = async () => {
        if (!invoice || !invoice._id) return;

        setPreviewLoading(true);
        setShowPreview(true);

        try {
            const url = urls.getInvoices(selectedCompanyId) + '/' + invoice._id + '/download';
            const req = {
                headers: {
                    username: authUser.username,
                    token: authUser.token,
                    AUTHORIZATION: authUser.token
                },
                method: 'GET'
            };

            const response = await fetch(url, req);
            const arrayBuffer = await response.arrayBuffer();
            // Create blob with explicit PDF MIME type
            const pdfBlob = new Blob([arrayBuffer], { type: 'application/pdf' });
            const pdfUrl = URL.createObjectURL(pdfBlob);
            setPreviewData(arrayBuffer);
            setPreviewUrl(pdfUrl);
        } catch (error) {
            console.error('Error loading preview:', error);
            Alert.fire({
                title: 'Error',
                text: 'Could not load invoice preview',
                icon: 'error'
            });
            setShowPreview(false);
        } finally {
            setPreviewLoading(false);
        }
    };

    const closePreview = () => {
        setShowPreview(false);
        setPreviewData(null);
        if (previewUrl) {
            URL.revokeObjectURL(previewUrl);
            setPreviewUrl(null);
        }
        setNumPages(null);
        setPageNumber(1);
    };

    let templateDescriptions = undefined;

    console.log(templates)
    if (addInvoice) {
        let template = templates.find(i => i._id == addInvoice.invoiceTemplateId);
        if (template && template.descriptions && template.descriptions.length > 0) templateDescriptions = template.descriptions;
    }

    const handleSave = () => {
        setSaving(true);
        saveInvoice((success) => {
            setSaving(false);
            if (success !== false) setEdit(false);
        });
    };

    return (
        <div>
            <div style={{ flex: 1 }}>

                {showSend &&
                    <div id="exampleModalLong"
                        tabIndex="-1"
                        className={showSend ? "modal fade show" : "modal fade"}
                        role="dialog"
                        data-backdrop="true"
                        aria-labelledby="exampleModalLongTitle"
                        aria-modal="true"
                        style={{ display: showSend ? 'block' : 'none' }} >

                        <div className="modal-dialog modal-dialog-scrollable modal-xl" role="document">
                            <div className="modal-content">
                                <div className="modal-header">
                                    <h4 className="modal-title">Send Invoice</h4>
                                    <button type="button" className="close" onClick={() => {
                                        setShowSend(false)
                                    }} data-dismiss="modal" aria-label="Close">
                                        <span aria-hidden="true">×</span>
                                    </button>
                                </div>
                                <div className="modal-body">
                                    <SendInvoice setShowSend={setShowSend} />
                                </div>
                                <div className="modal-footer justify-content-between">
                                </div>
                            </div>

                        </div>

                    </div>}
                {showPaid &&
                    <div id="paidInvoicedModal"
                        tabIndex="-1"
                        className={showPaid ? "modal fade show" : "modal fade"}
                        role="dialog"
                        data-backdrop="true"
                        aria-labelledby="paidInvoicedModalTitle"
                        aria-modal="true"
                        style={{ display: showPaid ? 'block' : 'none' }} >

                        <div className="modal-dialog modal-dialog-scrollable modal-xl" role="document">
                            <div className="modal-content">
                                <div className="modal-header">
                                    <h4 className="modal-title">Pay Invoice</h4>
                                    <button type="button" className="close" onClick={() => {
                                        setShowPaid(false)
                                    }} data-dismiss="modal" aria-label="Close">
                                        <span aria-hidden="true">×</span>
                                    </button>
                                </div>
                                <div className="modal-body">
                                    <PayInvoice setShowPaid={setShowPaid} />
                                </div>
                                <div className="modal-footer justify-content-between">
                                </div>
                            </div>

                        </div>

                    </div>}

                {showCredit &&
                    <div id="creditNoteModal"
                        tabIndex="-1"
                        className={showCredit ? "modal fade show" : "modal fade"}
                        role="dialog"
                        data-backdrop="true"
                        aria-labelledby="creditNoteModalTitle"
                        aria-modal="true"
                        style={{ display: showCredit ? 'block' : 'none' }} >

                        <div className="modal-dialog modal-dialog-scrollable modal-xl" role="document">
                            <div className="modal-content">
                                <div className="modal-header">
                                    <div>
                                        <h4 className="modal-title" id="creditNoteModalTitle">Credit note</h4>
                                        <div style={{ fontSize: 12, color: 'var(--text-secondary, #5A6B7A)', marginTop: 2 }}>
                                            Against {invoice && invoice.invoiceNumber}
                                        </div>
                                    </div>
                                    <button type="button" className="close" onClick={() => {
                                        setShowCredit(false)
                                    }} data-dismiss="modal" aria-label="Close">
                                        <span aria-hidden="true">×</span>
                                    </button>
                                </div>
                                <div className="modal-body">
                                    <CreditNote setShowCredit={setShowCredit} />
                                </div>
                            </div>
                        </div>

                    </div>}

                {/* Preview Modal */}
                {showPreview && (
                    <div id="previewModal"
                        tabIndex="-1"
                        className="modal fade show"
                        role="dialog"
                        data-backdrop="true"
                        aria-labelledby="previewModalTitle"
                        aria-modal="true"
                        style={{ display: 'block', backgroundColor: 'rgba(0,0,0,0.5)' }} >

                        <div className="modal-dialog modal-dialog-scrollable modal-xl" role="document" style={{ maxWidth: '90%', height: '90vh', margin: '5vh auto' }}>
                            <div className="modal-content" style={{ height: '100%' }}>
                                <div style={{
                                    background: '#1a3a4a',
                                    padding: '16px 24px',
                                    display: 'flex',
                                    justifyContent: 'space-between',
                                    alignItems: 'center',
                                    borderRadius: '4px 4px 0 0'
                                }}>
                                    <h4 style={{ margin: 0, color: 'white', fontWeight: 600 }}>
                                        <i className="fas fa-eye" style={{ marginRight: 10 }}></i>
                                        Invoice Preview
                                    </h4>
                                    <button type="button" onClick={closePreview} style={{
                                        background: 'transparent',
                                        border: 'none',
                                        color: 'white',
                                        fontSize: 20,
                                        cursor: 'pointer'
                                    }}>
                                        <i className="fas fa-times"></i>
                                    </button>
                                </div>
                                <div className="modal-body" style={{ padding: 0, flex: 1, display: 'flex', flexDirection: 'column', overflow: 'auto', background: '#525659' }}>
                                    {previewLoading ? (
                                        <div style={{
                                            flex: 1,
                                            display: 'flex',
                                            alignItems: 'center',
                                            justifyContent: 'center',
                                            flexDirection: 'column',
                                            gap: 16,
                                            color: '#fff',
                                            minHeight: '60vh'
                                        }}>
                                            <i className="fas fa-spinner fa-spin" style={{ fontSize: 32, color: '#19a6b7' }}></i>
                                            <span>Loading preview...</span>
                                        </div>
                                    ) : previewData ? (
                                        <div style={{
                                            padding: 16,
                                            minHeight: '60vh',
                                            maxHeight: '70vh',
                                            overflowY: 'auto',
                                            background: 'var(--bg, #EEF4F6)'
                                        }}>
                                            <Suspense fallback={<div style={{ padding: 24, textAlign: 'center', color: 'var(--text-secondary, #5A6B7A)', fontSize: 13 }}>Loading preview…</div>}>
                                                <PdfCanvas data={previewData} />
                                            </Suspense>
                                        </div>
                                    ) : (
                                        <div style={{
                                            flex: 1,
                                            display: 'flex',
                                            alignItems: 'center',
                                            justifyContent: 'center',
                                            color: '#fff',
                                            minHeight: '60vh'
                                        }}>
                                            <i className="fas fa-exclamation-circle" style={{ marginRight: 8 }}></i>
                                            Could not load preview
                                        </div>
                                    )}
                                </div>
                                <div style={{
                                    padding: '12px 24px',
                                    background: '#f8f9fa',
                                    borderTop: '1px solid #eee',
                                    display: 'flex',
                                    justifyContent: 'space-between',
                                    alignItems: 'center',
                                    gap: 12
                                }}>
                                    {/* Page Navigation */}
                                    <div style={{ display: 'flex', alignItems: 'center', gap: 12 }}>
                                        {numPages && numPages > 1 && (
                                            <>
                                                <button
                                                    type="button"
                                                    disabled={pageNumber <= 1}
                                                    onClick={() => setPageNumber(p => Math.max(1, p - 1))}
                                                    style={{
                                                        padding: '8px 12px',
                                                        borderRadius: 6,
                                                        border: '1px solid #ddd',
                                                        background: pageNumber <= 1 ? '#eee' : '#fff',
                                                        color: pageNumber <= 1 ? '#999' : '#333',
                                                        cursor: pageNumber <= 1 ? 'not-allowed' : 'pointer'
                                                    }}
                                                >
                                                    <i className="fas fa-chevron-left"></i>
                                                </button>
                                                <span style={{ fontSize: 14, color: '#666' }}>
                                                    Page {pageNumber} of {numPages}
                                                </span>
                                                <button
                                                    type="button"
                                                    disabled={pageNumber >= numPages}
                                                    onClick={() => setPageNumber(p => Math.min(numPages, p + 1))}
                                                    style={{
                                                        padding: '8px 12px',
                                                        borderRadius: 6,
                                                        border: '1px solid #ddd',
                                                        background: pageNumber >= numPages ? '#eee' : '#fff',
                                                        color: pageNumber >= numPages ? '#999' : '#333',
                                                        cursor: pageNumber >= numPages ? 'not-allowed' : 'pointer'
                                                    }}
                                                >
                                                    <i className="fas fa-chevron-right"></i>
                                                </button>
                                            </>
                                        )}
                                    </div>

                                    {/* Action Buttons */}
                                    <div style={{ display: 'flex', gap: 12 }}>
                                        <button
                                            type="button"
                                            onClick={() => previewUrl && window.open(previewUrl, '_blank')}
                                            style={{
                                                padding: '10px 20px',
                                                borderRadius: 6,
                                                border: 'none',
                                                background: '#19a6b7',
                                                color: 'white',
                                                fontWeight: 500,
                                                cursor: 'pointer',
                                                display: 'flex',
                                                alignItems: 'center',
                                                gap: 8
                                            }}
                                        >
                                            <i className="fas fa-external-link-alt"></i>
                                            Open in New Tab
                                        </button>
                                        <button
                                            type="button"
                                            onClick={closePreview}
                                            style={{
                                                padding: '10px 20px',
                                                borderRadius: 6,
                                                border: '1px solid #ddd',
                                                background: '#fff',
                                                color: '#666',
                                                fontWeight: 500,
                                                cursor: 'pointer'
                                            }}
                                        >
                                            Close
                                        </button>
                                    </div>
                                </div>
                            </div>
                        </div>
                    </div>
                )}


                <div style={{ width: '100%' }}>
                    {/* Error Alert */}
                    {!!error && (
                        <div style={{
                            background: '#fef0f0',
                            border: '1px solid #e84651',
                            padding: '12px 16px',
                            color: '#e84651',
                            fontWeight: 500
                        }}>
                            <i className="fas fa-exclamation-circle" style={{ marginRight: 8 }}></i>
                            {error}
                        </div>
                    )}

                    {addInvoice && (
                        <div style={{
                            margin: '2px 0 24px',
                            borderRadius: 18,
                            overflow: 'hidden',
                            border: '1px solid var(--glass-border, rgba(255,255,255,0.65))',
                            boxShadow: '0 18px 50px rgba(15,31,46,0.16)',
                            background: 'rgba(255,255,255,0.55)',
                            WebkitBackdropFilter: 'blur(22px) saturate(1.4)',
                            backdropFilter: 'blur(22px) saturate(1.4)'
                        }}>
                            {/* Header — transparent so the single frosted card surface
                                shows through; just a hairline divider below it. */}
                            <div style={{
                                background: 'transparent',
                                borderBottom: '1px solid rgba(15,31,46,0.07)',
                                padding: '12px 20px',
                                display: 'flex',
                                justifyContent: 'space-between',
                                alignItems: 'center'
                            }} className="no-print">
                                {/* Left: Back button and Title */}
                                <div style={{ display: 'flex', alignItems: 'center', gap: 16 }}>
                                    <button
                                        type="button"
                                        onClick={requestBack}
                                        style={hdrIconBtn}
                                        title="Back to list"
                                    >
                                        <i className="fas fa-arrow-left"></i>
                                    </button>
                                    <div>
                                        <h2 style={{ margin: 0, fontSize: 18, fontWeight: 800, fontFamily: 'var(--font-display)', color: 'var(--text)' }}>
                                            {docTitle(addInvoice, invoice)}
                                        </h2>
                                        {addInvoice.isCreditNote && (addInvoice.creditOfNumber || (invoice && invoice.creditOfNumber)) && (
                                            <div style={{ fontSize: 12, color: '#B45309', fontWeight: 600, marginTop: 2 }}>
                                                Credit of {addInvoice.creditOfNumber || (invoice && invoice.creditOfNumber)}
                                            </div>
                                        )}
                                    </div>
                                    <span style={{
                                        ...statusBadgeStyle,
                                        background: addInvoice.isCreditNote ? 'rgba(229,160,0,0.16)' : addInvoice.paid ? 'rgba(27,159,105,0.14)' : addInvoice.isQuote ? 'rgba(229,160,0,0.16)' : 'rgba(218,74,79,0.14)',
                                        color: addInvoice.isCreditNote ? '#8A3F07' : addInvoice.paid ? 'var(--success)' : addInvoice.isQuote ? '#a67400' : 'var(--danger)',
                                        border: 'none',
                                        fontSize: 11,
                                        fontWeight: 700,
                                        padding: '4px 12px'
                                    }}>
                                        {addInvoice.isCreditNote ? 'Credit' : addInvoice.paid ? 'Paid' : addInvoice.isQuote ? 'Quote' : 'Unpaid'}
                                    </span>
                                </div>

                                {/* Right: Action Icons */}
                                <div style={{ display: 'flex', alignItems: 'center', gap: 8 }}>
                                    {/* View Mode Actions */}
                                    {!edit && invoice && invoice._id && (
                                        <>
                                            <button type="button" onClick={openPreview} style={hdrIconBtn} title="Preview">
                                                <i className="fas fa-eye"></i>
                                            </button>
                                            <button type="button" onClick={() => setShowSend(true)} style={hdrIconBtn} title="Send Email">
                                                <i className="fas fa-paper-plane"></i>
                                            </button>
                                            <DownloadLink
                                                label={<i className="fas fa-download"></i>}
                                                style={hdrIconBtn}
                                                filename={documentFilename(invoice, invoice.to)}
                                                exportFile={() => Promise.resolve(getDataFromURL(urls.getInvoices(selectedCompanyId) + '/' + invoice._id + '/download', authUser))}
                                                title="Download PDF"
                                            />
                                            {/* A sent invoice is reversed with a credit note, never by
                                                editing it — so this only shows on real invoices, not on
                                                quotes and not on credit notes themselves. */}
                                            {!addInvoice.isQuote && !addInvoice.isCreditNote && (
                                                <button
                                                    type="button"
                                                    onClick={() => setShowCredit(true)}
                                                    style={{ ...hdrIconBtn, background: 'rgba(229,160,0,0.16)', color: '#B45309', width: 'auto', padding: '0 14px', gap: 6, fontWeight: 700, fontSize: 13 }}
                                                    title="Raise a credit note against this invoice"
                                                >
                                                    <i className="fas fa-undo"></i> Credit note
                                                </button>
                                            )}
                                            {/* A credit note is never settled by a payment — it is
                                                itself a reduction, so marking it paid is meaningless
                                                and would add a second credit to the statement. */}
                                            {!addInvoice.isCreditNote && (
                                                <button
                                                    type="button"
                                                    onClick={() => setShowPaid(true)}
                                                    style={addInvoice.paid ? hdrIconBtn : { ...hdrIconBtn, background: 'linear-gradient(135deg, #1B9F69, #14794f)', color: '#fff', width: 'auto', padding: '0 14px', gap: 6, fontWeight: 700, fontSize: 13 }}
                                                    title={addInvoice.paid ? "Edit Payment" : "Mark as Paid"}
                                                >
                                                    <i className={addInvoice.paid ? "fas fa-pencil-alt" : "fas fa-check"}></i>{!addInvoice.paid && ' Paid'}
                                                </button>
                                            )}
                                            <div style={{ width: 1, height: 24, background: 'rgba(15,31,46,0.12)', margin: '0 4px' }}></div>
                                            <button type="button" onClick={() => setEdit(true)} style={hdrTealBtn} title="Edit">
                                                <i className="fas fa-edit"></i> Edit
                                            </button>
                                        </>
                                    )}

                                    {/* Edit Mode Actions */}
                                    {edit && (
                                        <>
                                            {addInvoice._id && (
                                                <button
                                                    type="button"
                                                    onClick={() => {
                                                        Alert.fire({
                                                            title: 'Are you sure you want to delete this invoice?',
                                                            showDenyButton: true,
                                                            showCancelButton: false,
                                                            confirmButtonText: 'Yes',
                                                            denyButtonText: 'No',
                                                        }).then((result) => {
                                                            if (result.isConfirmed) {
                                                                deleteInvoice(updateshowAdd)
                                                            }
                                                        })
                                                    }}
                                                    style={{ ...hdrIconBtn, background: 'rgba(218,74,79,0.12)', color: 'var(--danger)' }}
                                                    title="Delete"
                                                >
                                                    <i className="fas fa-trash"></i>
                                                </button>
                                            )}
                                            {addInvoice._id && <div style={{ width: 1, height: 24, background: 'rgba(15,31,46,0.12)', margin: '0 4px' }}></div>}
                                            <button
                                                type="button"
                                                onClick={() => {
                                                    setSaving(true);
                                                    saveInvoice(function(err) {
                                                        setSaving(false);
                                                        if (!err) setEdit(false);
                                                    });
                                                }}
                                                disabled={saving}
                                                style={{ ...hdrTealBtn, opacity: saving ? 0.7 : 1, cursor: saving ? 'not-allowed' : 'pointer' }}
                                            >
                                                {saving ? <><i className="fas fa-spinner fa-spin"></i> Saving...</> : <><i className="fas fa-save"></i> Save</>}
                                            </button>
                                        </>
                                    )}
                                </div>
                            </div>

                            {/* Glass toolbar for document options */}
                            {edit && (() => {
                                const segGroup = { display: 'flex', gap: 3, background: 'rgba(15,31,46,0.05)', borderRadius: 10, padding: 3 };
                                const seg = (active) => ({ padding: '7px 14px', borderRadius: 8, border: 'none', fontWeight: 600, fontFamily: 'var(--font-display)', cursor: 'pointer', fontSize: 13, transition: 'all 0.15s ease', background: active ? '#fff' : 'transparent', color: active ? 'var(--primary)' : 'var(--text-secondary)', boxShadow: active ? '0 1px 3px rgba(0,0,0,0.08)' : 'none' });
                                return (
                                <div style={{
                                    background: 'transparent',
                                    padding: '12px 20px',
                                    display: 'flex',
                                    alignItems: 'center',
                                    gap: 10,
                                    flexWrap: 'wrap',
                                    borderBottom: '1px solid rgba(15,31,46,0.06)'
                                }}>
                                    {/* Document Type Toggle */}
                                    <div style={segGroup}>
                                        <button type="button" onClick={() => onChangeText('isQuote', false)} style={seg(!addInvoice.isQuote)}>Invoice</button>
                                        <button type="button" onClick={() => onChangeText('isQuote', true)} style={seg(addInvoice.isQuote)}>Quote</button>
                                    </div>

                                    {/* Divider */}
                                    {templates && templates.length > 1 && (
                                        <div style={{ width: 1, height: 28, background: 'rgba(15,31,46,0.12)', margin: '0 4px' }}></div>
                                    )}

                                    {/* Template Selector */}
                                    {templates && templates.length > 1 && (
                                        <div style={segGroup}>
                                            {templates.map(t => (
                                                <button
                                                    key={t._id}
                                                    type="button"
                                                    onClick={() => onChangeText('invoiceTemplateId', t._id)}
                                                    style={seg(addInvoice.invoiceTemplateId == t._id)}
                                                >
                                                    {t.invoiceTemplateName}
                                                </button>
                                            ))}
                                        </div>
                                    )}
                                </div>
                                );
                            })()}

                            {/* Content Area */}
                            <div style={cardStyle}>

                                {/* Client Section */}
                                <h4 style={{ ...sectionHeaderStyle, marginTop: 0 }}>Client Information</h4>
                                <ClientSelectorComponent key={'clientSelector'} viewOnly={!edit} header={'Client'} subtitle={'Click to choose who this invoice is for'} onChangeText={onChangeText} prop={'entityId'} value={addInvoice.entityId} />

                                {/* Dates Section */}
                                <h4 style={sectionHeaderStyle}>Dates</h4>
                                <div style={{ display: 'grid', gridTemplateColumns: 'repeat(auto-fit, minmax(200px, 1fr))', gap: 16 }}>
                                    <ItemDateComponent viewOnly={!edit} header={'Invoice Date'} onChangeText={onChangeText} prop={'invoiceDate'} value={addInvoice['invoiceDate']} />
                                    <ItemDateComponent viewOnly={!edit} header={'Due Date'} onChangeText={onChangeText} prop={'dueDate'} value={addInvoice['dueDate']} />
                                    {templateDescriptions && templateDescriptions.map(i => {
                                        if (i.type == 'date')
                                            return (<ItemDateComponent key={i.description} viewOnly={!edit} invert={true} header={i.label ? i.label : i.description} onChangeText={onChangeText} prop={i.description} value={addInvoice[i.description]} />);
                                        else return (<ItemEditComponent key={i.description} viewOnly={!edit} invert={true} header={i.label ? i.label : i.description} onChangeText={onChangeText} prop={i.description} value={addInvoice[i.description]} />)
                                    })}
                                </div>

                                {/* Paid Banner */}
                                {addInvoice.paid && (
                                    <div style={{
                                        backgroundColor: '#19a6b7',
                                        padding: 16,
                                        color: 'white',
                                        borderRadius: 6,
                                        marginTop: 20
                                    }}>
                                        <div style={{ display: 'flex', justifyContent: 'space-between', alignItems: 'center', marginBottom: 12 }}>
                                            <div style={{ fontWeight: 600, fontSize: 16 }}>
                                                <i className="fas fa-check-circle" style={{ marginRight: 8 }}></i>
                                                PAID
                                            </div>
                                            <button
                                                type="button"
                                                onClick={() => setShowPaid(true)}
                                                style={{
                                                    background: 'rgba(255,255,255,0.2)',
                                                    border: 'none',
                                                    color: 'white',
                                                    padding: '4px 12px',
                                                    borderRadius: 4,
                                                    cursor: 'pointer',
                                                    fontSize: 12,
                                                    fontWeight: 500
                                                }}
                                                title="Edit Payment Details"
                                            >
                                                <i className="fas fa-pencil-alt" style={{ marginRight: 6 }}></i>
                                                Edit
                                            </button>
                                        </div>
                                        <div style={{ display: 'grid', gridTemplateColumns: '1fr 1fr', gap: '8px 16px', fontSize: 13, opacity: 0.95 }}>
                                            {addInvoice.amountPaid && (
                                                <div>
                                                    <div style={{ opacity: 0.7, fontSize: 11, marginBottom: 2 }}>Amount Paid</div>
                                                    <div style={{ fontWeight: 600 }}>{addInvoice.amountPaid}</div>
                                                </div>
                                            )}
                                            {addInvoice.datePaid && (
                                                <div>
                                                    <div style={{ opacity: 0.7, fontSize: 11, marginBottom: 2 }}>Payment Date</div>
                                                    <div style={{ fontWeight: 600 }}>{moment(addInvoice.datePaid).format('DD MMM YYYY')}</div>
                                                </div>
                                            )}
                                            {addInvoice.methodPaid && (
                                                <div>
                                                    <div style={{ opacity: 0.7, fontSize: 11, marginBottom: 2 }}>Payment Method</div>
                                                    <div style={{ fontWeight: 600 }}>{addInvoice.methodPaid}</div>
                                                </div>
                                            )}
                                            {addInvoice.notes && (
                                                <div>
                                                    <div style={{ opacity: 0.7, fontSize: 11, marginBottom: 2 }}>Notes</div>
                                                    <div style={{ fontWeight: 600 }}>{addInvoice.notes}</div>
                                                </div>
                                            )}
                                        </div>
                                    </div>
                                )}

                                {/* Line Items Section */}
                                <h4 style={sectionHeaderStyle}>Line Items</h4>
                                <LineItemComponent entityId={addInvoice.entityId} view={!edit} updateLineItems={onChangeText} updateDiscount={onChangeText} updateTax={onChangeText} prop={'descriptions'} discount={addInvoice.discount} tax={addInvoice.tax} lineItems={addInvoice.descriptions} />

                                {/* Recurring Options - New Invoices Only */}
                                {!addInvoice._id && (
                                    <>
                                        <h4 style={sectionHeaderStyle}>Recurring Options</h4>
                                        <SwitchEditComponent header={'Make Recurring'} onChangeText={onChangeText} prop={'isRecurring'} value={addInvoice.isRecurring} />
                                        {addInvoice.isRecurring && (
                                            <div style={{ marginTop: 12 }}>
                                                <Select key={'Repeat'} header={'Frequency'} options={['day', 'week', 'month', 'year']} onChangeText={onChangeText} prop={'recurringType'} value={addInvoice.recurringType} />
                                            </div>
                                        )}
                                    </>
                                )}
                            </div>
                        </div>
                    )}
                </div>
            </div>
        </div >
    )
};

class AddInvoiceScreen extends React.Component {
    setInvoice = () => {

        const firstTemplate = (this.props.templates && this.props.templates.length) ? this.props.templates[0] : null;
        let nI = {
            invoiceTemplateId: firstTemplate ? firstTemplate._id : undefined,
            invoiceDate: new Date(),
            dueDate: moment().add(7, 'days')
        }

        if (this.props.invoice) {
            return { ...this.props.invoice };
        }
        else if (this.props.orgAppointment) {
            nI.discount = this.props.orgAppointment.discount;
            nI.descriptions = this.props.orgAppointment.lineItems;
            nI.entityId = this.props.orgAppointment.entityId;
            nI.to = this.props.orgAppointment.to;
            nI.toEmail = this.props.orgAppointment.toEmail;
            nI.appointmentId = this.props.orgAppointment._id;
        }

        return nI;
    }

    state = {
        addInvoice: this.setInvoice(),
        dirty: false
    }
    componentDidMount() {
        const $ = window.$;
        let invoiceDateEl = document.getElementById("invoiceDate");
        let dueDateEl = document.getElementById("dueDate");
        $(invoiceDateEl).datetimepicker({
            format: 'YYYY-MM-DD',
            date: new moment(this.state.addInvoice.invoiceDate)
        });
        $(dueDateEl).datetimepicker({
            format: 'YYYY-MM-DD',
            date: new moment(this.state.addInvoice.dueDate)
        });
    }

    componentDidUpdate(prevProps, prevState) {
        if ((JSON.stringify(prevProps.invoice) != JSON.stringify(this.props.invoice))) {
            this.setState({
                addInvoice: this.setInvoice(),
                // A different document is now loaded, so any pending-edit flag
                // belonged to the previous one. Without this it carried over and
                // the next invoice asked to discard changes nobody had made.
                dirty: false
            });
        }
    }

    saveInvoice = (updateshowAdd) => {
        console.log(this.state.addInvoice);
        this.props.dispatchCreateInvoice(this.state.addInvoice, done);
        function done(error) {
            if (!error) updateshowAdd(false);
        }
    }

    deleteInvoice = (updateshowAdd) => {
        this.props.dispatchDeleteInvoice(this.state.addInvoice._id, done);

        function done(error) {
            if (!error) updateshowAdd(false);
        }
    }

    // true = no unsaved changes (used to gate the discard-on-back confirm)
    compare = () => {
        return !this.state.dirty;
    }

    cancelChange = () => {
        this.setState({
            addInvoice: this.setInvoice(),
            dirty: false
        });
    }

    onChangeText = (key, value) => {
        // Children re-emit their current value on mount/normalisation. Treating
        // that as an edit marked a freshly opened invoice dirty, so going back
        // offered to discard changes the user never made. Only a value that
        // actually differs counts.
        const unchanged = JSON.stringify(this.state.addInvoice[key]) === JSON.stringify(value);

        let newInvoice = {
            ...this.state.addInvoice,
            [key]: value
        };

        this.setState({
            ...this.state,
            addInvoice: {
                ...newInvoice
            },
            dirty: this.state.dirty || !unchanged
        });
    }

    updateLineItems = (items) => {
        this.setState({
            addInvoice: {
                ...this.state.addInvoice,
                descriptions: items
            },
            dirty: true
        });
    }

    updateDiscount = (discount) => {
        this.setState({
            addInvoice: {
                ...this.state.addInvoice,
                discount
            },
            dirty: true
        });
    }

    updateClient = (entity) => {
        this.onChangeText('entityId', entity);
    }

    render() {
        return (
            <AddInvoiceComponent
                compare={this.compare}
                saveInvoice={this.saveInvoice}
                deleteInvoice={this.deleteInvoice}
                onChangeText={this.onChangeText}
                addInvoice={this.state.addInvoice}
                updateLineItems={this.updateLineItems}
                updateDiscount={this.updateDiscount}
                updateClient={this.updateClient}
                cancelChange={this.cancelChange}
                {...this.props} />
        );
    }
}

const mapStateToProps = state => ({
    authUser: state.auth.user,
    invoice: state.invoices.invoice,
    error: state.invoices.error,
    templates: state.invoiceTemplates.invoiceTemplates,
    entities: state.entities.entities,
    invoiceScreen: state.global.invoiceScreen,
    company: state.companies.company,
    selectedCompanyId: state.companies.selectedCompanyId,
    items: state.companies.items,
    entityTemplates: state.entityTemplates.entityTemplates,
})

const mapDispatchToProps = {
    dispatchDeleteInvoice: (id, callback) => deleteInvoice(id, callback),
    dispatchCreateInvoice: (invoice, callback) => createInvoice(invoice, callback),
    dispatchGetInvoice: (id) => getInvoice(id),
}

export default connect(mapStateToProps, mapDispatchToProps)(AddInvoiceScreen)
